import  ApiService  from '../../services/api.service'
import { TokenService } from '../../services/storage.service';
import axios from 'axios';

const state =  {
    currentLang: (localStorage.getItem('locale')) ? localStorage.getItem('locale') : "fi_FI",
    loading: false,
    orderDetails: [],
    paymentDetails: [],
    proceedLoading:false,
    userOrder:[],
    orderResponse: {
        message: '',
        variant: '',
        errmsg: []
    },
    confirmLoading: false,
    paymentConfirmation:null,
    additionalServices: [],
    orders: [],
    isShow: false,
    shippingDetailsCached: null,
    klarna_hpp_session : null
}
const getters = {
    currentLang: (state) => {
        return state.currentLang
    },
    loading: state => state.loading,
    proceedLoading: state => state.proceedLoading,
    orderDetails: state => state.orderDetails,
    paymentDetails: state => state.paymentDetails,
    billingAddress: state => state.billingAddress,
    shippingAddress: state => state.shippingAddress,
    orderResponse: (state) => state.orderResponse,
    userOrder: (state) => state.userOrder,
    confirmLoading: (state) => state.confirmLoading,
    paymentConfirmation: (state) => state.paymentConfirmation,
    additionalServices: (state) => state.additionalServices,
    orders: state => state.orders,
    isShow: (state) => state.isShow,
    shippingDetailsCached: (state) => state.shippingDetailsCached,
    klarna_hpp_session: (state) => state.klarna_hpp_session
}
const mutations = {
    setLoading(state, value) {
        state.loading = value;
    },
    setOrderDetails(state, value) {
        state.orderDetails = value
    },
    setPaymentDetails(state, value) {
        state.paymentDetails = value
    },
    setProceedLoading(state, value) {
        state.proceedLoading = value
    },
    setBillingAddress(state, value) {
        state.billingAddress = value
    },
    setShippingAddress(state, value) {
        state.shippingAddress = value
    },
    setError(state, data) {
        state.isShow = true;
        state.orderResponse.variant = 'danger';
        state.orderResponse.message = data.message;
        state.orderResponse.errmsg = data.errors;
    },
    setProfileError(state, data) {
        state.isShow = true;
        state.orderResponse.variant = 'danger';
        state.orderResponse.message = data.msg;
        state.orderResponse.errmsg = data;
    },
    resetState(state) {
        state.isShow = false;
        state.orderResponse.variant = '';
        state.orderResponse.message = '';
        state.orderResponse.errmsg = [];
    },
    setUserOrder(state, details) {
        state.userOrder = details
    },
    setConfirmLoading(state, value) {
        state.confirmLoading = value
    },
    setPaymentConfirmation(state, data) {
        state.paymentConfirmation = data
    },
    setAdditionalServices(state, services) {
        state.paymentConfirmation = services
    },
    setOrders(state, value) {
        state.orders = value
    },
    setShippingDetailsCached(state, value) {
        state.shippingDetailsCached = value
    },
    setKlarnaHPPSession(state, value) {
        state.klarna_hpp_session = value
    }
}
const actions = {
    // getOrderDetails({commit}, formdata) {
    //     return new Promise((resolve, reject) => {
    //         ApiService.post('/order/confirm', formdata) 
    //         .then(response => {
    //             commit('setOrderDetails', response.data)
    //             resolve();
    //         })
    //         .catch(error => {
    //             reject(error);
    //         })
    //         .finally(() => {
    //             commit('setProceedLoading', false);
    //         });
    //     });
    // },
    updateShippingDetails({commit}, formdata) {
        let token = TokenService.getToken();
        if(token) {
            return new Promise((resolve, reject) => {
                ApiService.post('/customer/order/shipping-details/update', formdata,
                { 'headers': { 'token': token} })
                .then(response => {
                    resolve();
                })
                .catch(error => {
                    reject(error);
                })
                .finally(() => {
                });
            });
        } else {
            let anonymousId = ''
            if(TokenService.getGuestToken()) {
                anonymousId = TokenService.getGuestToken()
            } else {
                TokenService.setGuestToken()
                anonymousId = TokenService.getGuestToken()
            }
            return new Promise((resolve, reject) => {
                ApiService.post('/anonymous/order/shipping-details/update?anonymous_id='+anonymousId, formdata)
                .then(response => {
                    resolve();
                })
                .catch(error => {
                    reject(error);
                })
                .finally(() => {
                });
            })
        }
    },
    setUserOrder({commit}, formdata) {
        commit('setUserOrder', formdata);
    },
    async confirmOrderWithPaytrail({commit}, formdata) {
        commit('setProceedLoading', true);
        commit('resetState')
        let token = TokenService.getToken();
        if(token) {
            return new Promise((resolve, reject) => {
                ApiService.post('/customer/order/confirm', [],
                { 'headers': { 'token': token} })
                .then(response => {
                    commit('setOrderDetails', response.data)
                    
                    resolve();
                })
                .catch(error => {
                    //commit('setResponse', error.response.data)
                    commit('setError', error.response.data)
                    reject(error);
                })
                .finally(() => {
                    commit('setProceedLoading', false);
                });
            })
        } else {
            let anonymousId = ''
            if(TokenService.getGuestToken()) {
                anonymousId = TokenService.getGuestToken()
            } else {
                TokenService.setGuestToken()
                anonymousId = TokenService.getGuestToken()
            }
            return new Promise((resolve, reject) => {
                ApiService.post('/anonymous/order/confirm?anonymous_id='+anonymousId, [])
                .then(response => {
                    commit('setOrderDetails', response.data)
                    commit('resetState')
                    resolve();
                })
                .catch(error => {
                    //commit('setResponse', error.response.data)
                    commit('setError', error.response.data)
                    reject(error);
                })
                .finally(() => {
                    commit('setProceedLoading', false);
                });
            })
        }
    },
    processPaymentWithPaytrail({commit}, formdata) {
        commit('setProceedLoading', true);
        let token = TokenService.getToken();
        if(token) {
            return new Promise((resolve, reject) => {
                ApiService.post('/customer/payment/process', formdata,
                { 'headers': { 'token': token} })
                .then(response => {
                    commit('setPaymentDetails', response.data)
                    resolve();
                })
                .catch(error => {
                    commit('setProceedLoading', false);
                    reject(error);
                })
            })
        } else {
            let anonymousId = ''
            if(TokenService.getGuestToken()) {
                anonymousId = TokenService.getGuestToken()
            } else {
                TokenService.setGuestToken()
                anonymousId = TokenService.getGuestToken()
            }
            return new Promise((resolve, reject) => {
                ApiService.post('/anonymous/payment/process?anonymous_id='+anonymousId, formdata,
                { 'headers': { 'token': token} })
                .then(response => {
                    commit('setPaymentDetails', response.data)
                    resolve();
                })
                .catch(error => {
                    commit('setProceedLoading', false);
                    reject(error);
                })
            })
        }
    },
    async confirmPaymentWithPaytrail({commit}, formdata) {
        commit('setConfirmLoading', true);
        let token = TokenService.getToken();
        if(token) {
            let userDetails = TokenService.getUserDetails()
            formdata.append('customer_id', userDetails.id)
            return new Promise((resolve, reject) => {
                ApiService.post('/customer/payment/confirm', formdata)
                .then(response => {
                    commit('setPaymentConfirmation', response.data)
                    resolve();
                })
                .catch(error => {
                    reject(error);
                })
                .finally(() => {
                    commit('setConfirmLoading', false);
                });
            })
        } else {
            let anonymous_id = TokenService.getGuestToken()
            formdata.append('anonymous_id', anonymous_id)
            return new Promise((resolve, reject) => {
                ApiService.post('/anonymous/payment/confirm', formdata)
                .then(response => {
                    commit('setPaymentConfirmation', response.data)
                     resolve();
                })
                .catch(error => {
                    reject(error);
                })
                .finally(() => {
                    commit('setConfirmLoading', false);
                });
            })
        }
        
    },
    getOrders({commit}, formdata) {
        commit('setProceedLoading', true);
        return new Promise((resolve, reject) => {
            
            ApiService.get('/customer/orders')
            .then(response => {
                commit('setOrders', response.data)
                resolve();
            })
            .catch(error => {
                reject(error);
            })
            .finally(() => {
                commit('setProceedLoading', false);
            });
        })
    },
    //getDetailsByOrderNumber
    async getDetailsByOrderNumber({commit}, orderNumber) {
        let token = TokenService.getToken();
        commit('setProceedLoading', true);
        if(token) {
            return new Promise((resolve, reject) => {
                ApiService.get('/customer/order/' + orderNumber, [],
                { 'headers': { 'token': token} })
                .then(response => {
                    commit('setOrderDetails', response.data) 
                        resolve()
                }).catch((e) => {
                    reject(e)
                }).finally(() => {
                    commit('setProceedLoading', false)
                })
            });
        } else {
            if(TokenService.getGuestToken()) {
                let anonymousId = TokenService.getGuestToken()
                const params = {
                    'anonymous_id': anonymousId
                }
                return new Promise((resolve, reject) => {
                    ApiService.get('/anonymous/order/'+orderNumber+'?anonymous_id='+anonymousId)
                    .then(response => {
                        commit('setOrderDetails', response.data) 
                        resolve()
                    }).catch((e) => {
                        reject()
                    }).finally(() => {
                        commit('setProceedLoading', false)
                    })
                });
            }
        }
    },

    getOrderDetails({commit}, orderId) {
        commit('setProceedLoading', true);
        return new Promise((resolve, reject) => {
            
            ApiService.get('/customer/order/'+orderId+'/details')
            .then(response => {
                commit('setOrderDetails', response.data)
                resolve();
            })
            .catch(error => {
                reject(error);
            })
            .finally(() => {
                commit('setProceedLoading', false);
            });
        })
    },
    resetError({commit}) {
        commit('resetState')
    },
    showError({commit}, value) {
        commit('setProfileError', value)
    },
    downloadInvoiceReceipt({commit}, orderId) {

        commit('setProceedLoading', true);
        return new Promise((resolve, reject) => {

            ApiService.getDownLoadFileWithAuth('/customer/order/'+orderId+'/invoice/download')
            .then(response => {
                let blob = new Blob([response.data], { type: 'application/pdf' })
                let link = document.createElement('a')
                link.href = window.URL.createObjectURL(blob)
                link.download = orderId+'.pdf'
                link.click();
            }).catch(error => {
                reject(error);
            })
            .finally(() => {
                commit('setProceedLoading', false);
            });

            // axios.get('/customer/order/'+orderId+'/invoice/download', {
            //     responseType: 'arraybuffer',
            //     headers: { token: localStorage.getItem('token') }
            // })
            // .then(response => {

            //     let blob = new Blob([response.data], { type: 'application/pdf' })
            //     let link = document.createElement('a')
            //     link.href = window.URL.createObjectURL(blob)
            //     link.download = orderId+'.pdf'
            //     link.click();
            // })
        })
    },
    setShippingDetailsToCached({commit}, value) {
        commit('setShippingDetailsCached', value);
    },
    getShippingDetailsCached({commit}, cartId) {
        let token = TokenService.getToken();
        commit('setProceedLoading', true);
        if(token) {
            return new Promise((resolve, reject) => {
                ApiService.get('customer/order/shipping-details/get?cartId=' + cartId)
                .then(response => {
                    commit('setShippingDetailsCached', response.data) 
                    resolve(response)
                }).catch((e) => {
                    reject()
                }).finally(() => {
                    commit('setProceedLoading', false);
                })
            })
        } else {
            let anonymousId = ''
            if(TokenService.getGuestToken()) {
                anonymousId = TokenService.getGuestToken()
            } else {
                TokenService.setGuestToken()
                anonymousId = TokenService.getGuestToken()
            }
            return new Promise((resolve, reject) => {
                ApiService.get('/anonymous/order/shipping-details/get?anonymous_id=' + anonymousId + '&cartId='+cartId)
                .then(response => {
                    commit('setShippingDetailsCached', response.data) 
                    resolve(response)
                }).catch((e) => {
                    reject()
                }).finally(() => {
                    commit('setProceedLoading', false);
                })
            })
        }
    },
    async processPaymentWithKlarna({commit}, formdata) {
        commit('setProceedLoading', true);
        let token = TokenService.getToken();
        if(token) {
            return new Promise((resolve, reject) => {
                ApiService.post('/customer/klarna_payment/process', formdata,
                    { 'headers': { 'token': token} })
                    .then(response => {
                        commit('setPaymentDetails', response.data)
                        resolve();
                    })
                    .catch(error => {
                        commit('setProceedLoading', false);
                        reject(error);
                    })
            })
        } else {
            let anonymousId = ''
            if(TokenService.getGuestToken()) {
                anonymousId = TokenService.getGuestToken()
            } else {
                TokenService.setGuestToken()
                anonymousId = TokenService.getGuestToken()
            }
            return new Promise((resolve, reject) => {
                ApiService.post('/anonymous/klarna_payment/process?anonymous_id='+anonymousId, formdata,
                    { 'headers': { 'token': token} })
                    .then(response => {
                        commit('setPaymentDetails', response.data)
                        resolve();
                    })
                    .catch(error => {
                        commit('setProceedLoading', false);
                        reject(error);
                    })
            })
        }
    },
    async confirmPaymentWithKlarna({commit}, formdata) {
        commit('setConfirmLoading', true);
        let token = TokenService.getToken();
        if(token) {
            let userDetails = TokenService.getUserDetails()
            formdata.append('customer_id', userDetails.id)
            return new Promise((resolve, reject) => {
                ApiService.post('/customer/klarna_payment/confirm', formdata)
                    .then(response => {
                        commit('setPaymentConfirmation', response.data)
                        resolve();
                    })
                    .catch(error => {
                        reject(error);
                    })
                    .finally(() => {
                        commit('setConfirmLoading', false);
                    });
            })
        } else {
            let anonymous_id = TokenService.getGuestToken()
            formdata.append('anonymous_id', anonymous_id)
            return new Promise((resolve, reject) => {
                ApiService.post('/anonymous/klarna_payment/confirm', formdata)
                    .then(response => {
                        commit('setPaymentConfirmation', response.data)
                        resolve();
                    })
                    .catch(error => {
                        reject(error);
                    })
                    .finally(() => {
                        commit('setConfirmLoading', false);
                    });
            })
        }

    },
    async readKlarnaHPPSession({commit}, formdata) {
        commit('setConfirmLoading', true);
        let token = TokenService.getToken();
        if(token) {
            let userDetails = TokenService.getUserDetails()
            formdata.append('customer_id', userDetails.id)
            return new Promise((resolve, reject) => {
                ApiService.post('/customer/klarna_payment/read-hpp-session', formdata)
                    .then(response => {
                        commit('setKlarnaHPPSession', response.data)
                        resolve();
                    })
                    .catch(error => {
                        commit('setKlarnaHPPSession', error.response.data)
                        reject(error);
                    })
                    .finally(() => {
                        commit('setConfirmLoading', false);
                    });
            })
        } else {
            let anonymous_id = TokenService.getGuestToken()
            formdata.append('anonymous_id', anonymous_id)
            return new Promise((resolve, reject) => {
                ApiService.post('/anonymous/klarna_payment/read-hpp-session', formdata)
                    .then(response => {
                        commit('setKlarnaHPPSession', response.data)
                        resolve();
                    })
                    .catch(error => {
                        commit('setKlarnaHPPSession', error.response.data)
                        reject(error);
                    })
                    .finally(() => {
                        commit('setConfirmLoading', false);
                    });
            })
        }

    },
}
export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}